import { render, staticRenderFns } from "./DicCheckboxGroupTalent.vue?vue&type=template&id=1279e4e5&scoped=true&"
import script from "./DicCheckboxGroupTalent.vue?vue&type=script&lang=js&"
export * from "./DicCheckboxGroupTalent.vue?vue&type=script&lang=js&"
import style0 from "./DicCheckboxGroupTalent.vue?vue&type=style&index=0&id=1279e4e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1279e4e5",
  null
  
)

export default component.exports